import React, { useEffect, useState, type FunctionComponent } from 'react';
import { Stack, Text, HStack } from '@chakra-ui/react';
import { DetailsDrawer } from '../../components/detailsDrawer/DetailsDrawer';
import { DetailsElement } from '../../components/detailsDrawer/DetailsElement';
import { type OutbankFeatureData, type OutbankFeatureNotes } from '../../interface/Issue';
import { Request as apiRequest } from '../../helper';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    featureDetails: OutbankFeatureData;
}

export const Details: FunctionComponent<Props> = (props: Props) => {
    const [notes, setNotes] = useState<string[]>();
    const { featureDetails, isOpen, onClose } = props;
    const { iid, featureId, name, description } = featureDetails;

    useEffect(() => {
        setNotes(undefined);
        async function getIssuesNotes(): Promise<void> {
            const response = await apiRequest.get<OutbankFeatureNotes>({
                path: `/gitlab/issue/outbankfeaturenotes/${iid}/${featureId}`,
            });
            setNotes(response.data.notes);
        }
        getIssuesNotes();
    }, [iid, featureId]);

    return (
        <DetailsDrawer
            isOpen={isOpen}
            onClose={onClose}
            title={
                <HStack>
                    <Text>User request details</Text>
                </HStack>
            }
            size="lg"
        >
            <Stack>
                <DetailsElement label="Name" value={name} />
                <DetailsElement label="Description" value={description.split('<details>')[0]} />
                {notes && notes.length > 0 && (
                    <>
                        <DetailsElement label="Notes">
                            {notes.map(function (item, idx) {
                                return (
                                    <Text key={idx}>
                                        {item.split('[[DP')[0]}
                                        <hr />
                                    </Text>
                                );
                            })}
                        </DetailsElement>
                    </>
                )}
            </Stack>
        </DetailsDrawer>
    );
};
